/*
  Copyright (C) 2022 by USHIN, Inc.

  This file is part of U4U.

  U4U is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  U4U is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with U4U.  If not, see <https://www.gnu.org/licenses/>.
*/
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { isInt } from '../utils'

interface SettingsState {
  darkMode: boolean
  searchLimit: number
}

const initialSettingsState: SettingsState = {
  darkMode: true,
  searchLimit: 20
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialSettingsState,
  reducers: {
    toggleDarkMode: state => {
      state.darkMode = !state.darkMode
    },
    setSearchLimit: (state, action: PayloadAction<{
      searchLimit: number
    }>) => {
      const { searchLimit } = action.payload
      if (isInt(searchLimit) && searchLimit >= 1 && searchLimit <= 100) {
        state.searchLimit = searchLimit
      }
    }
  }
})

export const {
  toggleDarkMode,
  setSearchLimit
} = settingsSlice.actions
export default settingsSlice.reducer
